import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SucursalService } from 'src/app/pages/services/sucursales.service';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { Sucursal } from 'src/app/shared/models/sucursales.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import Swal from 'sweetalert2';
import { MatSelectChange } from '@angular/material/select';
import { CiudadService } from 'src/app/pages/services/ciudades.service';
import { RequestResponseGetAllSucursal } from 'src/app/shared/models/sucursales.interface';

pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'app-lista-sucursales',
  templateUrl: './lista-sucursales.component.html',
  styleUrls: ['./lista-sucursales.component.css']
})
export class ListaSucursalesComponent implements OnInit {

  @Output() onDebounce: EventEmitter<boolean> = new EventEmitter();
  debouncer: Subject<boolean> = new Subject();
  sucursales: Sucursal[] = [];
  update_sucursales: Sucursal = {
    id: 0,
    nombre: "",
    direccion: "",
    idciudad: 0,
    centroCosto: 1,
  };
  ciudades_dropdown: any[] = [];
  ciudadSeleccionada: number;

  fileName = 'sucursales.xlsx';
  exportexcel(): void {
    let element = document.getElementById('tabla');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);

  }

  public convetToPDF() {

    var datos = [];
    datos.push([
      'CENTRO COSTO',
      'NOMBRE',
      'DIRECCION',
    ]);


    this.sucursales.map(function (item) {

      datos.push([
        item.centroCosto,
        item.nombre,
        item.direccion,
      ]);
    });


    var documentDefinition = {

      content: [

        { text: 'SUCURSALES', style: 'header', fontSize: 30 },
        {
          table: {

            body: datos

          }
        }
      ]
    };

    pdfMake.createPdf(documentDefinition).open();
  }
  displayedColumns: string[] = ['centro', 'nombre', 'direccion', 'actions'];
  dataSource = new MatTableDataSource<Sucursal>(this.sucursales);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private alert: AlertHelper,
    private modalService: NgbModal,
    private sucursalesService: SucursalService,
    private ciudadService: CiudadService,
  ) { }

  ngOnInit(): void {
    this.debouncer
      .pipe(debounceTime(500))
      .subscribe(valor => {
        this.onDebounce.emit(valor);
      });
    this.sucursalesService.traerSucursales().subscribe(
      (res: RequestResponseGetAllSucursal | any) => {  // Usa `any` temporalmente si no encaja con la interfaz

        let sucursalesArray = [];

        if (res && res.success) {
          // Verifica si `res.data` es un array o si tiene una propiedad `data` anidada
          if (Array.isArray(res.data)) {
            sucursalesArray = res.data;
          } else if (res.data && Array.isArray(res.data.data)) {
            sucursalesArray = res.data.data;
          } else {
            console.error("Formato inesperado de respuesta de API:", res);
            return;
          }

          // Mapeamos los datos para asegurarnos de obtener la estructura deseada
          this.sucursales = sucursalesArray.map((sucursal: any) => ({
            id: sucursal.id,
            nombre: sucursal.nombre,
            direccion: sucursal.direccion,
            centroCosto: sucursal.centroCosto,
            idciudad: sucursal.Sucursal_Ciudad ? sucursal.Sucursal_Ciudad.id : null,
            ciudad: sucursal.Sucursal_Ciudad ? sucursal.Sucursal_Ciudad.nombre : "Sin ciudad",
            region: sucursal.Sucursal_Ciudad?.CiudadRegion ? sucursal.Sucursal_Ciudad.CiudadRegion.nombre : "Sin región",
          })).sort((a, b) => a.nombre.localeCompare(b.nombre));

          // Actualizar MatTableDataSource
          this.dataSource = new MatTableDataSource<Sucursal>(this.sucursales);
          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          }, 0);

        } else {
          console.error("Error: `res.data` no es un array válido.", res);
          this.sucursales = [];
        }

      },
      (error) => {
        console.error("Error al obtener sucursales", error);
      }
    );



    this.ciudadService.traerCiudades().subscribe(res => {
      if (res.success) {
        this.ciudades_dropdown = res.data.sort((a, b) => a.nombre.localeCompare(b.nombre));
      } else {
        this.alert.error_mail('Hubo un error al recibir las ciudades.');
        console.error(res.msg);
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sucursales_List && changes.sucursales_List.currentValue) {

      this.dataSource = new MatTableDataSource<Sucursal>(this.sucursales);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  open(content: any, id: number) {
    this.update_sucursales.id = id
    this.sucursalesService.obtenerSucursal(id).subscribe(res => {
      if (res.success) {
        const sucursal = res.data.data;
        this.update_sucursales.nombre = sucursal.nombre;
        this.update_sucursales.direccion = sucursal.direccion;
        this.update_sucursales.idciudad = sucursal.idciudad ?? 0;
        this.update_sucursales.centroCosto = sucursal.centroCosto;
        this.ciudadSeleccionada = sucursal.idciudad ?? 0;
        this.modalService.open(content);
      } else {
        this.alert.error_small('Ocurrio un error al obtener los datos');
        console.error(res.msg);
      }

    });
  }

  limpiar_sucursales() {
    this.update_sucursales.nombre = ""
  }

  Actualizar_Sucursales() {
    if (this.update_sucursales.nombre.trim().length == 0) {
      this.alert.error_small('Los campos no pueden estar vacios.')
      return
    }
    this.update_sucursales.idciudad = this.ciudadSeleccionada;

    this.sucursalesService.actualizarSucursal(this.update_sucursales).subscribe(res => {
      if (res.success == true) {
        this.alert.success_small(res.msg!)
        this.modalService.dismissAll();
        this.debouncer.next(true);
      } else {
        this.alert.error_small(res.msg!)
        //console.log(res);
      }
    })


  }

  Eliminar_Sucursal(content: any, id: number) {


    Swal.fire({
      title: 'Eliminar?',
      text: "Se eliminara el sucursal",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff0000',
      cancelButtonColor: '#6c736e',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.isConfirmed) {


        this.sucursalesService.eliminarSucursal(id).subscribe(res => {
          if (res.success == true) {
            this.alert.success_small(res.msg!)
            this.debouncer.next(true);
          } else {
            this.alert.error_small(res.msg!)
          }
        })
      }
    })
  }

  ObtenerCiudad(event: MatSelectChange) {
    const ciudad = event.value;
    console.log({ ciudad });
    this.update_sucursales.idciudad = ciudad;
  }

  //FITRAL
  applyFilter(event: Event) {
    //Funcion para filtar cualquier columna por el texto buscado
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


}
